module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "side-menu has-sub-site-nav",
    class: [_vm.isOpen ? 'open' : 'close']
  }, [_c('div', {
    staticClass: "side-menu-brand d-xl-none"
  }, [_c('img', {
    staticClass: "ruyi-logo align-self-center",
    attrs: {
      "src": require("@/assets/images/logos/ruyi.svg")
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/close.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "side-menu-body"
  }, [_c('ul', {
    staticClass: "site-nav",
    on: {
      "click": _vm.close
    }
  }, [_c('li', {
    staticClass: "d-xl-none"
  }, [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".home")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.home.title')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "site-nav sub-site-nav"
  }, [_c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.company-value.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.talents.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.social-responsibility.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility.title')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "site-nav sub-site-nav"
  }, [_c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.rd.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.global-presence.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.vertical-integration.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration.title')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "site-nav sub-site-nav"
  }, [_c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#ruyi-brand-network'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-01.title')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#smcp'
      }
    }
  }, [_vm._v("SMCP")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#renown'
      }
    }
  }, [_vm._v("RENOWN")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "site-nav sub-site-nav"
  }, [_c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#green-energy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-01.title')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#powering-future'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-02.title')))])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "site-nav-separator d-none d-xl-block"
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.ruyi-news.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.ruyi-news.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "d-none d-md-block"
  }, [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.contact.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.contact.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "d-xl-none"
  }, [_c('button', {
    staticClass: "link site-nav-link",
    on: {
      "click": _vm.showSitemapOverlay
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sitemap.title')))])])]), _vm._v(" "), _c('language-switcher', {
    staticClass: "d-md-none"
  }), _vm._v(" "), _c('follow-us', {
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "stock-info"
    }
  }, [(_vm.isHome) ? _c('stock-info', {
    staticClass: "d-xl-none"
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a33ca16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SideMenu.vue
// module id = 625
// module chunks = 1